module.exports = __webpack_public_path__ + "img/12525609000163.af9ef726.png";